import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import Typography from '@material-ui/core/Typography';

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const styles = theme => ({
  sliderComponent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  typographyLeft: {
    marginRight: 10,
  },
  typographyRight: {
    marginLeft: 10,
  },
  datePicker: {
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  textFieldInput: {
    width: '75%',
    [theme.breakpoints.down('xs')]: {
      width: '50%',
    },
  },
});

export class ValueSelection extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.setDateValues = this.setDateValues.bind(this);
  }

  setDateValues(eventTarget) {
    const { value } = this.props;
    let dateValues = [];
    dateValues = eventTarget.id === 'beginDate'
      ? [eventTarget.value, value[1]] : [value[0], eventTarget.value];
    return dateValues;
  }

  handleChange(event) {
    const { updateFilter, formInputType } = this.props;
    const value = formInputType === 'slider'
      ? event : formInputType === 'date' ? this.setDateValues(event.target) : event.target.value;
    updateFilter(value);
  }

  render() {
    const {
      formInputType, value, options, classes, fieldName,
    } = this.props;
    let valueSelection;
    switch (formInputType) {
      case 'text':
        valueSelection = (
          <div className={classes.textField}>
            <div className={classes.textFieldInput}>
              <TextField
                fullWidth
                id="value"
                value={value}
                placeholder="Name"
                onChange={this.handleChange}
              />
            </div>
          </div>
        );
        break;
      case 'number':
        valueSelection = (
          <div className={classes.textField}>
            <div className={classes.textFieldInput}>
              <TextField
                fullWidth
                id="number"
                value={value}
                placeholder="Num"
                type="number"
                onChange={this.handleChange}
              />
            </div>
          </div>
        );
        break;
      case 'slider':
        valueSelection = (
          <div className={classes.sliderComponent}>
            <Typography className={classes.typographyLeft}>
              {value[0]}
            </Typography>
            <Range
              min={0}
              max={fieldName === 'offspring count' ? 20 : 100}
              step={1}
              defaultValue={value}
              onChange={(this.handleChange)}
            />
            <Typography className={classes.typographyRight}>
              {value[1]}
            </Typography>
          </div>
        );
        break;
      case 'date':
        valueSelection = (
          <div className={classes.datePicker}>
            <TextField
              id="beginDate"
              type="date"
              defaultValue={value[0]}
              onChange={this.handleChange}
            />
            <TextField
              id="endDate"
              type="date"
              defaultValue={value[1]}
              onChange={this.handleChange}
            />
          </div>
        );
        break;
      case 'select':
        valueSelection = (
          <Select
            value={value}
            onChange={this.handleChange}
          >
            {options.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        );
        break;
      default:
        valueSelection = (
          <p>
            {'Not a supported input type'}
          </p>
        );
        break;
    }
    return (
      valueSelection
    );
  }
}

ValueSelection.propTypes = {
  fieldName: PropTypes.string.isRequired,
  formInputType: PropTypes.string.isRequired,
  updateFilter: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  classes: PropTypes.shape().isRequired,
};

export default withStyles(styles)(ValueSelection);



// WEBPACK FOOTER //
// ./src/components/search/advanced-search/ValueSelection.jsx